import defaultValue from "./reportSlice";

export default defaultValue;
export * from "./reportSlice";
